<template>
  <v-dialog v-model="active" max-width="1200px" persistent>
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on: on }" />
    </template>
    <v-card class="l-card" height="100%">
      <v-container fluid class="background pa-0 l-card__title__container">
        <v-row align="center" class="ma-0 l-card__title__row">
          <v-col cols="12" class="pa-4">
            <span class="l-card__title__text">Adicionar lote ao crechário </span>
            <span class="l-card__title__text font-weight-bold pl-1">{{ crechario.dadosCreche.nmProdutor }}</span>
          </v-col>
          <v-btn
            absolute
            right
            top
            icon
            x-small
            color="#E5E8E7"
            @click="active = !active"
          >
            <v-icon>fa fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid class="pa-0 ma-0 l-card__content__container_c">
        <v-row
          align="center"
          class="ma-0 l-card__filter__row"
          md-gutter
          v-on:keyup.enter="pesquisar"
        >
          <v-col>
            <v-text-field
              dense
              label="Produtor"
              outlined
              hide-details
              clearable
              v-model="nmProdutor"
              @click:clear="pesquisar"
            />
          </v-col>
          <v-col>
            <v-text-field
              dense
              label="UEP"
              outlined
              hide-details
              clearable
              v-only-int
              v-model="nrUnidadeExploracao"
              @click:clear="pesquisar"
            />
          </v-col>
          <v-col>
            <v-text-field
              dense
              label="Qt. mínima de vazio sanitário"
              outlined
              hide-details
              v-only-int
              clearable
              v-model="qtVazioSanitario"
              @click:clear="pesquisar"
            />
          </v-col>
          <v-col>
            <v-row align="center" justify="center" class="ma-0">
              <v-btn-toggle dense class="white--text">
                <v-btn color="primary" class="white--text" @click="limparFiltros">Limpar</v-btn>
                <v-btn color="#2BC1B6" class="white--text mx-1" @click="pesquisar">Buscar</v-btn>
              </v-btn-toggle>
            </v-row>
          </v-col>
        </v-row>
        <v-divider />
        <v-row v-if="listaLotesDestino.length === 0" class="ma-0">
          <v-col cols="12" class="pa-4">
            <span>Nenhum registro encontrado</span>
          </v-col>
        </v-row>
        <v-row class="ma-0 l-card__content__row">
	        <v-virtual-scroll
			        bench="3"
			        :items="chunkedLotes"
			        item-height="386"
	            min-height="400"
	            max-height="750"
			        width="100%"
	        >
		        <template v-slot="{ item }">
			        <v-row class="ma-0">
				        <v-col v-for="(loteDestino) in item" :key="loteDestino['idPlanejamentoAlojamentoLoteDestino']"
				               cols="12"  md="4" lg="3" xl="3">
					        <alocar-lotes-card :lotesSelecionados.sync="selectedDays" :loteDestino="loteDestino"
					                           :listaDatas="listaDatas"
					                           :crechario="crechario"/>
				        </v-col>
			        </v-row>
		        </template>
	        </v-virtual-scroll>
          <v-overlay absolute :value="loading">
            <v-row align="center" justify="center" class="ma-0">
              <v-progress-circular indeterminate size="42" color="secondary" />
            </v-row>
          </v-overlay>
        </v-row>
      </v-container>
      <v-container fluid class="l-card__content__action white pa-0 elevation-5">
        <v-row class="ma-0 pa-2 px-4">
          <v-btn
            depressed
            class="blue--text"
            @click="active = !active"
          >Cancelar</v-btn>
          <v-spacer />
          <v-btn
            depressed
            color="#2BC1B6"
            :loading="loading"
            class="white--text"
            @click="validarLotesDestino()"
          >Concluir</v-btn>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import AlocarLotesCard from "./AlocarLotesCard";
import {MODELS, UTILS} from "../../resources";
import {mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "AlocarLotesDialog",
  components: { AlocarLotesCard },
  props: {
	  listaLotesDestino: {
    	type: Array,
		  default: () => [],
    	required: true,
	  },
	  crechario: {
    	type: Object,
    	required: true,
	  },
	  listaDatas: {
    	type: Array,
    	required: true,
	  },
  },
  data: () => ({
	  //Caso queiram paginar os lotesDestinos
	  // totalPages: 1,
		// itensPagina: 48,
	  // page: 1,
		selectedDays: [],
    active: false,
    loading: false,
	  nmProdutor: '',
		nrUnidadeExploracao: null,
		qtVazioSanitario: null,
	  queryFiltros: {
			nmProdutor: '',
			nrUnidadeExploracao: null,
			qtVazioSanitario: null
		},
  }),
  methods: {
		...mapMutations("planejamentoAlojamento", ["mtChangeLoteDestinoAlojamento", "mtChangeListaLoteAlocado"]),
    limparFiltros() {
			this.nmProdutor = null
			this.nrUnidadeExploracao = null
			this.qtVazioSanitario = null

			this.pesquisar()
    },
    pesquisar() {
    	this.queryFiltros = {
				nmProdutor: this.nmProdutor,
				nrUnidadeExploracao: this.nrUnidadeExploracao,
				qtVazioSanitario: this.qtVazioSanitario
			}
    },
		validarLotesDestino() {
			this.loading = true

			const lotesDestinoSelecionados = this.selectedDays.map(selecao => {
				return this.listaLotesDestino[selecao.id]
			}).filter(loteDestino => loteDestino.idPlanejamentoAlojamentoLoteDestino === null ||
          loteDestino.idPlanejamentoAlojamentoLoteDestino < 1)

			if (lotesDestinoSelecionados.length === 0) {
				this.concluirAlojamento()
			} else {
				let requests = lotesDestinoSelecionados.map(loteDestino => {
					return this.$axios.post(`/planejamento-alojamento-lote-destino/`, loteDestino)
							.then(res => {
								if (!res.data) return
								if (!res.data[0].data) return

								const lote = _.extend(res.data[0].data, {
									id: loteDestino.id,
									nrDistanciaCreche: loteDestino.nrDistanciaCreche
								})

								this.mtChangeLoteDestinoAlojamento({
									cdEstabelecimentoCreche: this.crechario.dadosCreche.cdEstabelecimento,
									lote: lote
								})
							})
							.catch(error => {
								this.$store.commit("setSnack", {type: "error", msg: error})
								this.loading = false
							})
				})

				Promise.all(requests).then(() => this.concluirAlojamento())
			}
		},
		concluirAlojamento() {
			const cdPlanejamentoAlojamento = this.$route.params.id

			let lotesSelecionados = this.selectedDays.map(selecao => {

				const existeLoteAlocado = this.listaLotesAlocados.find(lote => {
					return (lote.cdPlanejamentoAlojamentoLoteDestino ===
							this.listaLotesDestino[selecao.id].idPlanejamentoAlojamentoLoteDestino &&
							lote.stDiaAlocado === selecao.stDiaAlocado &&
							lote.cdLoteProducaoCreche === this.crechario.cdLoteProducaoCreche &&
							lote.cdCrecheSemLote === this.crechario.cdCrecheSemLote)
				})

				if(existeLoteAlocado && existeLoteAlocado.idPlanejamentoAlojamentoAlocado > 0) return existeLoteAlocado
				else return new MODELS.LOTE_ALOCADO.constructor(
						this.crechario.cdLoteProducaoCreche,
						this.crechario.cdCrecheSemLote,
						this.listaLotesDestino[selecao.id].idPlanejamentoAlojamentoLoteDestino,
						selecao.stDiaAlocado,
						null,
						selecao.dtAlocado,
						cdPlanejamentoAlojamento,
						null
				)
			})

			this.$axios.put(`/planejamento-alojamento-alocado/${this.$route.params.id}/editar-alocados/`,
					[ ...lotesSelecionados,
						...this.listaLotesAlocadosForaCrechario(this.crechario.cdCrecheSemLote, this.crechario.cdLoteProducaoCreche)
					])
					.then(res => {
						if (!res.data) return
						if (!res.data[0].data) return

						this.mtChangeListaLoteAlocado(res.data[0].data ? res.data[0].data : [])
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error})
					})
					.finally(() => {
						this.loading = false
					})
		},
	  //Paginacao
		// verificaPaginacao() {
		// 	if (this.totalPages > 0 && this.page > this.totalPages) this.page = this.totalPages
		// },
  },
  computed: {
  	...mapState("planejamentoAlojamento", ["listaLotesAlocados"]),
  	...mapGetters("planejamentoAlojamento", ["listaLotesAlocadosForaCrechario", "getLotesSelecionadosByCreche"]),
	  chunkedLotes() {
			let array = this.listaLotesDestino
			if (!array) return []

			const queryFiltros = this.queryFiltros

			if (queryFiltros.nmProdutor)
				array = array.filter(lote => lote.nmProdutor.toLowerCase().startsWith(queryFiltros.nmProdutor.toLowerCase()))

			if (queryFiltros.nrUnidadeExploracao > 0)
				array = array.filter(lote => parseInt(lote.nrUnidadeExploracao) === parseInt(queryFiltros.nrUnidadeExploracao))

			if (queryFiltros.qtVazioSanitario > 0)
				array = array.filter(lote => queryFiltros.qtVazioSanitario <= lote.qtVazioSanitario)

		  //paginacao
			// this.totalPages = Math.ceil(array.length / this.itensPagina)
			// this.verificaPaginacao()

			let totalChunks = [];
			let chunkLength = 1;

			switch (this.$vuetify.breakpoint.name) {
				case 'md':
					chunkLength = 3;
					break;
				case 'lg':
					chunkLength = 4;
					break;
				case 'xl':
					chunkLength = 4;
					break;
			}

			if (chunkLength <= 0) {
				return array;
			}
			// Paginacao
			// const startIndex = (this.page - 1) * this.itensPagina
			// const endIndex = startIndex + this.itensPagina > array.length ? array.length : startIndex + this.itensPagina
			// array = array.slice(startIndex, endIndex)

			// Loop through the data and divide it into chunks
			for (let i = 0; i < array.length; i += chunkLength) {
				totalChunks.push(array.slice(i, i + chunkLength));
			}

			// Return the chunks of data
			return totalChunks;
		},
  },
	watch: {
  	active(ativo){
  		if (!ativo) this.selectedDays = []
		  else {
		  	const lotesAlocados = this.getLotesSelecionadosByCreche(this.crechario.cdCrecheSemLote, this.crechario.cdLoteProducaoCreche)

			  this.selectedDays = lotesAlocados.map(lote => ({
				  stDiaAlocado: lote.stDiaAlocado,
				  dtAlocado: lote.dtAlocado,
				  id: this.listaLotesDestino.findIndex(loteDestino => {
					  return loteDestino.idPlanejamentoAlojamentoLoteDestino === lote.loteDestino.idPlanejamentoAlojamentoLoteDestino
				  })
			  }))
		  }
	  }
	},
};
</script>

<style scoped lang="scss">
::v-deep .v-dialog {
  overflow-y: hidden !important;
  height: 90% !important;
  position: relative !important;
  z-index: 99999999;
}

.l-card {
  position: relative !important;
}

.l-card__title__container {
  height: 54px;
  position: relative;
}

.l-card__title__row {
  height: 54px;
  position: relative;
}

.l-card__title__text {
  font: Regular 16px/21px Roboto;
  letter-spacing: 0;
  color: #e5e8e7;
}

.l-card__content__container_c {
  background: #f7f7f7 0 0 no-repeat padding-box;
  opacity: 1;
  position: relative;
}

.l-card__content__action {
  position: absolute !important;
  z-index: 99999999 !important;
  bottom: 0 !important;
  left: 0 !important;
}
</style>
